import React, { useEffect, useState } from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { useDispatch } from "react-redux";

import Renewal from "../containers/Renewal/Renewal";
import EditRenewal from "../containers/Renewal/EditRenewal";
import Liability from "../containers/Renewal/Liability";
import Property from "../containers/Renewal/Property";
import Drivers from "../containers/Renewal/Drivers";
import Cars from "../containers/Renewal/Cars";
import Checkout from "../containers/Renewal/Checkout";
import Complete from "../containers/Renewal/Complete";
import Policy from "../containers/Renewal/Policy";
import HeaderNew from "../containers/Renewal/HeaderNew";
import insp, { install } from "inspectlet-es";
import ReactGa from "react-ga";
import usePageTracking from "./usePageTracking";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const AppRenewal = (props) => {
	const {
		renewalId,
		makeModels,
		municipalities,
		stripePubKey,
		customerName,
		helloSignCid,
		gaTrackingId,
		inspectletId,
		allowCreditCardPayments,
		productExceptionMessages,
	} = props;

	const dispatch = useDispatch();

	install(inspectletId);

	const stripePromise = loadStripe(stripePubKey);

	useEffect(() => {
		if (renewalId) {
			dispatch({ type: "SET_RENEWAL_ID", payload: renewalId });
		}
	}, [renewalId]);

	usePageTracking(gaTrackingId);

	return (
		<>
			<HeaderNew customerName={customerName} />
			<Switch>
				<Route exact path={`/v3/renewals/${renewalId}/react`}>
					<Policy customerName={customerName} />
				</Route>
				<Route exact path={`/v3/renewals/${renewalId}/react/renewal`}>
					<Renewal />
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/edit`}>
					<EditRenewal />
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/liability`}>
					<Liability />
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/property`}>
					<Property />
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/drivers`}>
					<Drivers municipalities={municipalities} />
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/vehicles`}>
					<Cars makeModels={makeModels} productExceptionMessages={productExceptionMessages}/>
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/checkout`}>
					<Elements stripe={stripePromise}>
						<Checkout
							helloSignCid={helloSignCid}
							allowCreditCardPayments={allowCreditCardPayments}
						/>
					</Elements>
				</Route>
				<Route path={`/v3/renewals/${renewalId}/react/complete`}>
					<Complete />
				</Route>
			</Switch>
		</>
	);
};

export default AppRenewal;
